import React from 'react';
import ReactDOM from 'react-dom';

import { Alert, Divider } from 'antd';
import ReactMarkdown from 'react-markdown';

import InputAnswer from '../InputAnswer';

import defaultStyles from './style.less';

class QuestionFillBlanks extends React.Component {

  constructor (props) {
    console.log('constructor QuestionFillBlanks');
    super(props);
    this.state = {
      inputWidth : '24px'
    }
    this.measureRef = React.createRef();
    this.onInput = this.onInput.bind(this);
  }

  componentDidMount() {
    console.log('componentDidMount');
    this.setState({
      inputWidth : (this.measureRef.current.clientWidth + 24) + 'px'
    });
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    return {
      active: document.activeElement && document.activeElement.id
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot.active) {
      document.getElementById(snapshot.active).focus();
    }
  }

  onInput(e) {
    if (this.props.onSetAnswer) this.props.onSetAnswer(e);
  };

  render() {
    const { question,
      answer,
      disabled,
      mutating,
      onSetAnswer,
      showValidationMessage,
      styles = {
        step: defaultStyles.step,
        descCombo: defaultStyles.descCombo,
        measurer: defaultStyles.measurer,
      }
    } = this.props;

    if (!question)
      return null;

    const { task, comment, hrefs } = question;

    const longestOption = hrefs.reduce((acc, href) => {
      const [, ...options] = decodeURI(href.slice(1)).split('|').filter(s => !!s);
      const correctValue = options.filter(o => o.includes('*'))[0].replace(/\*/g, '').toLowerCase();
      const placeholder = options.filter(o => !o.includes('*'))[0] || 'Fill in the blanks';
      const bigger = correctValue.length > placeholder.length ? correctValue : placeholder;
      return acc.length > bigger.length ? acc : bigger;
    }, '');

    return (
      <div className={styles.step}>
        <div className={styles.descInput}>
          <ReactMarkdown
            key={question.slug}
            source={task}
            renderers={{
              link: props => {
                //add check if href has special format, otherwise return simple hyperlink
                const regcheck = /\?\d+\|.+/;
                if (!regcheck.test(decodeURI(props.href)))
                  return <a href={props.href}>{props.children}</a>;
                return (<InputAnswer inputStyle={{ width:this.state.inputWidth, textAlign:'center' }} key={props.href} href={props.href} onChange={this.onInput} question={question} answer={answer} disabled={disabled} mutating={mutating} />)
              },
              paragraph:'div',
            }}
          />
          { showValidationMessage ? <Alert type="error" message="You must fill all blanks" /> : null }
          { disabled && (
              <>
                <Divider />
                <ReactMarkdown source={comment} />
              </>
            )
          }
          <div ref={this.measureRef} className={styles.measurer}>{longestOption}</div>
        </div>
      </div>
    );
  }
}

export default QuestionFillBlanks;
